
import { Component } from 'vue-property-decorator';
import CreateCampaignForm from './create.vue';
import { Send } from '@/components/form-base';
import ApiServices from '@/services';

@Component
export default class EditCampaignForm extends CreateCampaignForm  {
  get modalTitle(){
    return this.t('Edit Campaign')
  }
  
  save(){
    this.submit(false);
    this.tutorial.close();
  }

  async load() {
    const campaign = await this.campaignApi.get(this.campaign_id);
    this.edit = true;

    this.form = {
      ...campaign,
      useTrafficLoss: campaign.trafficLossPercent !== null,
      usePostback: campaign.postbackPercent !== null,
      botFiltersMode: campaign.botFiltersMode || 0,
      maxCostEnabled: !!campaign.maxCostEnabled,
      maxCostUsd: campaign.maxCostUsd ?? null,
      maxCostAction: campaign.maxCostEnabled
        ? (campaign.maxCostAction ?? 1)
        : 1,
      maxCostBotOfferId: campaign.maxCostBotOfferId || null,
      trackingDomainId:campaign.trackingDomainId || '', // set "account default" domain with id=''
      trafficSource: campaign.trafficSource || {
        name: this.t('None'),
        id: ''
      },
      sendCustomConversionMode: campaign.sendCustomEventPostback?.mode || 'all',
      sendCustomConversionIds: campaign.sendCustomEventPostback?.ids || [],
      doNotSendNotSpecifiedConversions: campaign.sendCustomEventPostback?.doNotSendNotSpecifiedConversions || false
    };

    delete this.form.sendCustomEventPostback;

    this.oldHash = this.getCurrentHash();
    this.campaignInitialState = campaign
  }

  @Send()
  submit(forceOpenLinks: boolean = false) {
    this.emptyUrlSend = !this.form.destinationUrl;

    const form = this.processForm(this.form);

    return this.campaignApi.putUpdate(this.campaign_id, form).then(async(response) => {
      const { id } = response;
      const { campaigns } = this.dialogActionsEvents;

      this.reportUtils.updateName('campaigns', id);
      await ApiServices.getUserProfile()
      this.bus.emit('refresh-report');
      this.bus.emit('toast-success', this.t('Campaign has been changed'));

      this.trackAnalytics('campaign_edit',form)

      this.close();

      if(forceOpenLinks) {
        campaigns.campaignLinks(id);
      }
    });
  }

}
